import axios from "axios";

// Healiary International (en) — API client.
//
// NOTE: this file is intentionally git-ignored (.gitignore) because it is
// environment-specific. It was restored on 2026-08-03 after being found missing
// from the repo. Keep a copy in the secure handover store (Notion) — without it
// the frontend cannot build.
//
// Production (EU): the app talks to nginx at https://en.healiary.com/api/, which
// proxies /api -> the NestJS backend (port 4003). The trailing slash matters:
// SignUp.js builds OAuth redirects as `${common.baseURL}auth/google`, and axios
// combineURLs also relies on consistent joining, so we always enforce it below.
//
// For local/dev builds, override via REACT_APP_API_BASE_URL, e.g.:
//   REACT_APP_API_BASE_URL=http://localhost:4002/
const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://en.healiary.com/api/";

const API_BASE_URL = RAW_BASE_URL.endsWith("/")
  ? RAW_BASE_URL
  : RAW_BASE_URL + "/";

export default axios.create({ baseURL: API_BASE_URL });

export const common = {
  baseURL: API_BASE_URL,
};
